module.exports = __webpack_public_path__ + "img/select-lang-btn-zh.86655c52.png";